/**
 * Avenue Perfumes — Arabic text for the Lably product badges
 *
 * The MEN / WOMEN / UNISEX badges on product cards are drawn by the Lably
 * labels app, not by the theme: the text lives in the app's own settings
 * (a shop metafield) and is painted into the card client-side, so neither the
 * theme nor Shopify's translation layer can reach it and it stayed English on
 * /ar/.
 *
 * This swaps those three words after the app has rendered. It is deliberately
 * narrow: it only ever looks inside Lably's own elements, and only at text
 * that is exactly one of the three badge words, so a product legitimately
 * called "Men" is never touched.
 *
 * The app paints late and repaints often (collection cards, the cart drawer's
 * recommendations, infinite scroll), and on some loads it finishes after the
 * last mutation this script would otherwise see. So there is a MutationObserver
 * AND a short ladder of timed sweeps — each sweep is cheap and idempotent, and
 * once a badge reads رجالي there is nothing left for it to match.
 *
 * If Lably ever gains per-language label text, set it there instead and delete
 * this file along with its <script> tag in snippets/localization.liquid.
 */
(function () {
  'use strict';

  var WORDS = {
    MEN: 'رجالي',
    WOMEN: 'نسائي',
    WOMAN: 'نسائي',
    UNISEX: 'للجنسين'
  };

  var HOSTS = '[data-lably-placement], ._lably_item_';

  var state = {
    ready: false,
    sweeps: 0,
    changed: 0
  };

  window.AP_LABELS = state;

  if (document.documentElement.lang !== 'ar') return;
  state.ready = true;

  function translateWithin(host) {
    if (!host || host.nodeType !== 1) return;

    var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null, false);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var trimmed = text.trim();
      if (!trimmed) continue;

      var arabic = WORDS[trimmed.toUpperCase()];
      if (!arabic) continue;

      // Keep whatever whitespace the app put around the word.
      node.nodeValue = text.replace(trimmed, arabic);
      state.changed++;
    }
  }

  function sweep() {
    state.sweeps++;
    var hosts = document.querySelectorAll(HOSTS);
    for (var i = 0; i < hosts.length; i++) translateWithin(hosts[i]);
  }

  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      sweep();
    }, 60);
  }

  function start() {
    sweep();

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Belt and braces for the loads where the app settles after the observer
    // has gone quiet.
    [300, 900, 2000, 4000].forEach(function (delay) {
      window.setTimeout(sweep, delay);
    });
  }

  function boot() {
    if (document.body) {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', sweep);
})();
